window.btnLoader = {
  start: function ($btn, text) {
    const hasText = text != null && String(text).trim() !== '';
    const spinnerClass = hasText ? 'fa-solid fa-spinner fa-spin me-2' : 'fa-solid fa-spinner fa-spin';
    const html = hasText ? `<i class="${spinnerClass}"></i>${text}` : `<i class="${spinnerClass}"></i>`;
    if (typeof jQuery !== 'undefined' && $btn instanceof jQuery) {
      if (!$btn.prop('disabled')) {
        $btn.data('original-text', $btn.html());
      }
      $btn.prop('disabled', true);
      $btn.html(html);
    } else {
      if (!$btn.disabled) {
        $btn.dataset.originalText = $btn.innerHTML;
      }
      $btn.disabled = true;
      $btn.innerHTML = html;
    }
  },
  stop: function ($btn) {
    if (typeof jQuery !== 'undefined' && $btn instanceof jQuery) {
      $btn.prop('disabled', false);
      const originalText = $btn.data('original-text');
      if (originalText) {
        $btn.html(originalText);
      }
    } else {
      $btn.disabled = false;
      if ($btn.dataset.originalText) {
        $btn.innerHTML = $btn.dataset.originalText;
      }
    }
  }
};

window.notify = function (type, message) {
  if (typeof iziToast !== 'undefined') {
    iziToast[type]({
      title: type.charAt(0).toUpperCase() + type.slice(1),
      message: message,
      position: 'topRight',
      timeout: 5000,
      close: true,
      progressBar: true,
      layout: 2
    });
  }
};

window.getApiErrorMessage = function (xhr, fallback) {
  try {
    const d = xhr.responseJSON;
    if (d && d.message) return d.message;
    if (xhr.responseText) {
      const parsed = JSON.parse(xhr.responseText);
      if (parsed && parsed.message) return parsed.message;
    }
  } catch (e) {
    if (typeof console !== 'undefined' && console.warn) {
      console.warn('getApiErrorMessage:', e);
    }
  }
  return fallback || 'An error occurred';
};

window.confirmAsync = function (message) {
  return new Promise(function (resolve) {
    const $modal = $('#confirmModal');
    const $msg = $('#confirmModalMessage');
    const $yes = $('#confirmModalYes');
    const $no = $('#confirmModalNo');
    if (!$modal.length || !$msg.length) {
      resolve(window.confirm(message));
      return;
    }
    let resolved = false;
    function finish(result) {
      if (resolved) return;
      resolved = true;
      $modal.off('hidden.bs.modal shown.bs.modal');
      $yes.off('click');
      $no.off('click');
      $modal.modal('hide');
      $('.modal-backdrop.confirm-modal-backdrop').removeClass('confirm-modal-backdrop');
      resolve(result);
    }
    $msg.text(message || 'Are you sure?');
    $modal.one('hidden.bs.modal', function () { finish(false); });
    $modal.one('show.bs.modal', function () {
      function tagBackdrop() {
        const $backdrops = $('.modal-backdrop');
        if ($backdrops.length) {
          $backdrops.last().addClass('confirm-modal-backdrop').css('transition', 'none');
        }
      }
      setTimeout(tagBackdrop, 0);
      $modal.one('shown.bs.modal', tagBackdrop);
    });
    $yes.one('click', function () { finish(true); });
    $no.one('click', function () { finish(false); });
    $modal.modal('show');
  });
};

(function () {
  function refreshNotificationBadges() {
    if (typeof jQuery === 'undefined') {
      return;
    }
    const $b = jQuery('#notificationBadge');
    const $bm = jQuery('#notificationBadgeMobile');
    if (!$b.length && !$bm.length) {
      return;
    }
    fetch('/api/notifications/unreadCount', { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        if (!data || data.success !== true) {
          return;
        }
        const n = parseInt(data.count, 10) || 0;
        const text = n > 99 ? '99+' : String(n);
        if (n > 0) {
          $b.text(text).show();
          $bm.text(text).show();
        } else {
          $b.hide();
          $bm.hide();
        }
      })
      .catch(function () {});
  }

  window.refreshNotificationBadges = refreshNotificationBadges;

  function escapeHtml(s) {
    if (s == null) {
      return '';
    }
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/"/g, '&quot;');
  }

  function escapeAttr(s) {
    if (s == null) {
      return '';
    }
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;');
  }

  function previewTypeLabel(t) {
    return t === 'sms' ? 'SMS' : 'System';
  }

  function formatNotificationTimestamp(raw) {
    if (raw == null || String(raw).trim() === '') {
      return '';
    }
    const s = String(raw).trim();
    let d;
    if (s.includes('T') || s.endsWith('Z')) {
      d = new Date(s);
    } else {
      d = new Date(s.replace(' ', 'T'));
    }
    if (Number.isNaN(d.getTime())) {
      return s;
    }
    return d.toLocaleString(undefined, {
      dateStyle: 'short',
      timeStyle: 'short'
    });
  }

  window.formatNotificationTimestamp = formatNotificationTimestamp;

  function loadNotificationPreview($container) {
    if (typeof jQuery === 'undefined' || !$container || !$container.length) {
      return;
    }
    $container.html('<div class="text-center text-muted small py-3 px-3">Loading…</div>');
    fetch('/api/notifications/list?limit=10&offset=0', { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        if (!data || data.success !== true) {
          $container.html(
            '<div class="text-center text-danger small py-3 px-3">Could not load notifications.</div>'
          );
          return;
        }
        const rows = data.notifications || [];
        if (!rows.length) {
          $container.html(
            '<div class="text-center text-muted small py-4 px-3">No notifications yet.</div>'
          );
          return;
        }
        const parts = [];
        rows.forEach(function (row) {
          const tl = previewTypeLabel(row.type);
          const badgeClass = row.type === 'system' ? 'bg-primary' : 'bg-secondary';
          const title = row.title != null && row.title !== '' ? escapeHtml(row.title) : '';
          const rawBody = row.body == null ? '' : String(row.body);
          const bodyEsc = escapeHtml(rawBody);
          const bodyShort =
            bodyEsc.length > 120 ? bodyEsc.substring(0, 120) + '…' : bodyEsc;
          const dateStr = escapeHtml(formatNotificationTimestamp(row.created_at));
          const actionUrl = row.action_url == null || row.action_url === '' ? '' : String(row.action_url);
          const nid = row.id != null ? parseInt(row.id, 10) : 0;
          const dataNidAttr =
            nid > 0 ? ' data-notification-id="' + String(nid) + '"' : '';
          const openTag = actionUrl
            ? '<a href="' +
              escapeAttr(actionUrl) +
              '"' +
              dataNidAttr +
              ' class="list-group-item list-group-item-action py-2 px-3 border-0 border-bottom text-decoration-none text-reset">'
            : '<div' + dataNidAttr + ' class="list-group-item py-2 px-3 border-0 border-bottom">';
          const closeTag = actionUrl ? '</a>' : '</div>';
          parts.push(
            openTag +
              '<div class="d-flex justify-content-between align-items-start gap-2">' +
              '<span class="badge ' +
              badgeClass +
              '">' +
              tl +
              '</span>' +
              '<small class="text-muted text-nowrap">' +
              dateStr +
              '</small>' +
              '</div>' +
              (title ? '<div class="fw-semibold small mt-1">' + title + '</div>' : '') +
              '<div class="small text-muted mt-1">' +
              bodyShort +
              '</div>' +
              closeTag
          );
        });
        $container.html(parts.join(''));
      })
      .catch(function () {
        $container.html(
          '<div class="text-center text-danger small py-3 px-3">Could not load notifications.</div>'
        );
      });
  }

  if (typeof jQuery !== 'undefined') {
    jQuery(function () {
      refreshNotificationBadges();
      setInterval(refreshNotificationBadges, 60000);

      jQuery('#notificationTopNav').on('shown.bs.dropdown', function () {
        loadNotificationPreview(jQuery('#notificationDropdownList'));
      });

      jQuery('#notificationDropdownList').on(
        'click',
        '[data-notification-id]',
        function (e) {
          if (e.button !== 0 || e.ctrlKey || e.metaKey || e.shiftKey) {
            return;
          }
          const el = this;
          const nid = parseInt(jQuery(el).attr('data-notification-id'), 10);
          if (!nid || nid < 1) {
            return;
          }
          const href = el.tagName === 'A' ? el.getAttribute('href') : '';
          if (href) {
            e.preventDefault();
          }
          fetch('/api/notifications/markRead', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: nid }),
          })
            .then(function (r) {
              if (r.ok && typeof window.refreshNotificationBadges === 'function') {
                window.refreshNotificationBadges();
              }
            })
            .catch(function () {})
            .finally(function () {
              if (href) {
                window.location.href = href;
              }
            });
        }
      );
    });
  }

  const currentPath = window.location.pathname;
  const pagePaths = {
    dashboard: ['/dashboard', '/'],
    home: ['/', '/home'],
    account: ['/account'],
    login: ['/login'],
    cart: ['/cart'],
    notifications: ['/notifications'],
    marketplace: ['/marketplace', '/categories']
  };

  function isPageActive(page, href) {
    if (href && currentPath === href) return true;
    const paths = pagePaths[page];
    if (!paths) return false;
    if (typeof paths === 'function') return paths(currentPath);
    return paths.indexOf(currentPath) !== -1;
  }

  if (typeof jQuery !== 'undefined') {
    jQuery('.mobile-nav-item').each(function () {
      const $item = jQuery(this);
      const page = $item.data('page');
      const href = $item.attr('href');
      if (isPageActive(page, href)) {
        $item.addClass('active');
      }
    });
  }
})();